<div class="product-review" *ngIf="totalReviews > 0">
  <div class="mb-10 w-full">
    <div class="rating-summary">
      <div class="average-rating mb-5">
        <div class="rating-number">
          <span class="slash"></span>
          <span class="text-2xl font-semibold">Review</span>
        </div>
        <div class="star">
          {{ averageRating }}
          <fa-icon
            *ngFor="let _ of [1, 2, 3, 4, 5]"
            [icon]="faStar"
            [ngClass]="{
              'text-gray-400': _ >= averageRating,
              'text-yellow-500': _ <= averageRating
            }"></fa-icon>
        </div>
        <div class="total-review text-sm text-gray-500">
          {{ totalReviews }}
          <span>Total Reviews</span>
        </div>
      </div>
      <div class="rating-group">
        <div class="rating-item" *ngFor="let rate of groupReviewRating">
          <div class="label flex items-center gap-x-1">
            {{ rate.star }}
            <fa-icon [icon]="faStar" class="text-yellow-500"></fa-icon>
            <div
              [title]="rate.total"
              class="relative h-3 w-full overflow-hidden rounded-full bg-gray-300">
              <div
                [title]="rate.total"
                class="absolute top-0 left-0 h-full bg-yellow-500"
                [style]="'width:' + rate.percent + '%'"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="review-images-container flex-1" *ngIf="reviewImages.length > 1">
      <div
        class="subtitle"
        [ngStyle]="{
          'margin-left': reviewImages.length < 9 ? '0px' : '10px'
        }">
        User's Review Photos
      </div>
      <div class="review-images">
        <!-- <div
            class="swiper-container"
            [swiper]="reviewImagesSwiperConfig"
            [ngStyle]="{ width: reviewImages.length < 9 ? '100%' : '90%' }">
            <div
              class="swiper-wrapper py-2"
              [ngClass]="reviewImages.length < 9 ? 'disabled' : ''">
              <div class="swiper-slide" *ngFor="let image of reviewImages">
                <div class="c-img-s">
                  <img [src]="image" />
                </div>
              </div>
            </div>
          </div>
          <div *ngIf="reviewImages.length > 8">
            <div class="swiper-button-prev"></div>
            <div class="swiper-button-next"></div>
          </div> -->
      </div>
    </div>
  </div>
  <div class="review-list" #reviewList>
    <div class="review-item" *ngFor="let review of reviews">
      <div class="user-info flex gap-x-3">
        <div class="user-image">
          <div class="c-img-r">
            <img
              class="aspect-square w-14 flex-none rounded-full"
              [src]="
                review.user.propic_path
                  ? review.user.propic_path
                  : userDefaultPhoto
              "
              [alt]="review.user.name"
              (error)="userErrorImg()" />
          </div>
        </div>
        <div>
          <div class="user-name text-lg text-primary-darkest">
            {{ review.user.name }}
          </div>
          <p class="timestamp text-sm text-gray-400">
            {{ review.formattedTimeStamp }}
          </p>
          <div class="review">
            <div class="header">
              <div class="">
                <span class="star">
                  <fa-icon
                    *ngFor="let _ of [1, 2, 3, 4, 5]"
                    [icon]="faStar"
                    [ngClass]="{
                      'text-gray-400': _ >= review.rate,
                      'text-yellow-500': _ <= review.rate
                    }"></fa-icon>
                </span>
              </div>
              <div
                class="variant text-sm text-primary-md-dark"
                *ngIf="review.variant_name">
                Varian {{ review.variant_name }}
              </div>
            </div>
            <div class="content">
              <div class="user-review-text">"{{ review.review }}"</div>
              <div class="dis-flex">
                <div
                  class="c-img-s mr-2"
                  [ngStyle]="{ 'width.px': 80 }"
                  *ngFor="let image of review.product_review_images">
                  <img [src]="image.path" />
                </div>
              </div>
            </div>
            <div class="footer">
              <!-- <div class="useful-review">
                              <div class="useful-info">20 orang menemukan ulasan ini bermanfaat</div>
                              <div class="useful-question">Apakah ulasan ini bermanfaat? <a>Ya</a><a>Tidak</a></div>
                          </div> -->
              <div class="view-reply-button" *ngIf="review.replies.length > 0">
                <a (click)="showReply(review)">
                  <fa-icon
                    [icon]="review.showReply ? faSortUp : faSortDown"
                    [ngClass]="review.showReply ? 'up' : ''"></fa-icon>
                  <span *ngIf="review.showReply">Hide Replies</span>
                  <span *ngIf="!review.showReply">Show Replies</span>
                </a>
              </div>
            </div>
            <div
              class="replies"
              *ngIf="review.showReply && review.replies.length > 0">
              <div class="reply-item" *ngFor="let reply of review.replies">
                <div class="header">
                  <div class="profile-image">
                    <div class="c-img-r">
                      <img
                        [src]="
                          reply.profile.logo_path
                            ? reply.profile.logo_path
                            : shopDefaultLogo
                        "
                        [alt]="review.user.name"
                        (error)="shopErrorImg()" />
                    </div>
                  </div>
                  <div class="profile-info">
                    <div class="profile-name">{{ reply.profile.name }}</div>
                    <div class="timestamp">{{ reply.formattedTimeStamp }}</div>
                  </div>
                </div>
                <div class="content">
                  <div class="message">
                    {{ reply.message }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <fc-pagination
    [totalItem]="totalReviews"
    [currentPage]="1"
    (pageChange)="pageChange($event)"></fc-pagination>
</div>

<div class="empty-product-review" *ngIf="totalReviews < 1">
  <h3 class="mb-3 font-medium uppercase text-primary-darkest">
    Reviews ({{ totalReviews }})
  </h3>
  <div class="info text-center">
    <img
      src="assets/images/product/empty-review-illust.png"
      class="illust mx-auto mb-4 w-full max-w-[400px]" />
    <div class="caption text-xl font-medium text-primary-darkest">
      No reviews yet
    </div>
    <div class="subcaption text-lg text-primary-md-dark">
      Be the first one to review this product? why not?
    </div>
  </div>
</div>
